import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, } from 'reactstrap';
import moment from 'moment';

import api from "../../../../api";
import functions from "../../../../functions";
import ParadigmaModal from "../../../../components/ParadigmaModal/ParadigmaModal.js";
import ParadigmaLabeledInput from "../../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js";
import ParadigmaDatePicker from "../../../../components/ParadigmaDatePicker/ParadigmaDatePicker.js";
import ParadigmaCheckBoxInput from "../../../../components/ParadigmaCheckboxInput/ParadigmaCheckBoxInput.js";

import imgNotAvailable from "../../../../../public/img/image-not-found.png";
import './styles.css';

class Modal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Titulo: "",
      Contenido_HTML: "",
      Imagen: "",
      Adjunto: "",
      Adjunto_Link: "",
      Destacada: false,
      Fecha: moment().format("L"),
      postVariables: ['Titulo', 'Imagen', 'Contenido_HTML', 'Fecha', 'Destacada', 'Adjunto'],
      errors: [],
    };
  }

  static propTypes = {
    onSubmit: PropTypes.func,
    id: PropTypes.func,
    action: PropTypes.oneOf(['CREATE', 'EDIT', 'DETAIL', 'DELETE']).isRequired,
  }

  resetForm() {
    this.setState({
      Titulo: "",
      Contenido_HTML: "",
      Adjunto_Link: "",
      Imagen: "",
      Adjunto: "",
      Destacada: false,
      Fecha: moment().format("L"),
      errors: [],
    });
  }

  getData() {
    const { postVariables } = this.state;
    let data = {};
    postVariables.forEach(x => {
      data[x] = this.state[x];
    });
    data.Fecha = moment(data.Fecha, "DD/MM/YYYY").format("YYYY/MM/DD").replaceAll("/", "-");
    return data;
  }

  setData(data) {
    if (data.success) {
      this.setState({
        Titulo: data.Titulo,
        Contenido_HTML: data.Contenido_HTML,
        Imagen: data.Imagen,
        Adjunto_Link: data.Adjunto,
        Adjunto: data.Adjunto,
        Destacada: data.Destacada,
      })
    }
  }

  setErrors(errors) {
    this.setState({
      errors: errors,
    });
  }

  onChangeField(field, value) {
    this.setState(prevState => {
      let errors = prevState.errors;
      if (errors) errors[field] = null;
      prevState.errors = errors;
      prevState[field] = value;
      return prevState;
    });
  }

  getError(field) {
    let errors = this.state.errors;
    if (errors) return errors[field];
    else return null;
  }

  modalVars() {
    const { action } = this.props;
    if (action == "CREATE") {
      return {
        get: false,
        submitType: "POST",
        title: "Nueva Novedad",
        buttonTitle: "Nuevo",
        danger: false,
        buttonIcon: "fa fa-plus fa-lg",
        successMessage: "La novedad ha sido creada con éxito.",
        saveButton: true,
        saveButtonLabel: "Guardar",
        buttonClass: "",
        disabled: false,
      };
    } else if (action == "EDIT") {
      return {
        get: true,
        submitType: "PATCH",
        title: "Editar Novedad",
        buttonTitle: "Editar",
        danger: false,
        buttonIcon: "fa fa-pencil fa-lg",
        successMessage: "La novedad ha sido editada con éxito.",
        saveButton: true,
        saveButtonLabel: "Guardar",
        buttonClass: "",
        disabled: false,
        id: this.props.id,
      };
    } else if (action == "DETAIL") {
      return {
        get: true,
        submitType: null,
        title: "Novedad",
        buttonTitle: "Ver",
        danger: false,
        buttonIcon: "fa fa-search fa-lg",
        successMessage: "",
        saveButton: false,
        buttonClass: "",
        disabled: true,
        id: this.props.id,
      };
    } else if (action == "DELETE") {
      return {
        get: true,
        submitType: "DELETE",
        title: "Eliminar Novedad",
        buttonTitle: "Eliminar",
        saveButtonLabel: "Eliminar",
        danger: true,
        buttonIcon: "fa fa-trash fa-lg",
        successMessage: "La novedad ha sido eliminada con éxito.",
        saveButton: true,
        buttonClass: "btn-danger",
        disabled: true,
        id: this.props.id,
      };
    }
  }

  updateImage(evt) {
    evt.preventDefault();
    let node = document.getElementById("raised-button-file");
    if (node != undefined && node != null && node.files != null && node.files.length == 1) {
      const reject = (Image) => this.onChangeField('Imagen', Image);
      const resolve = (resizedImage) => this.onChangeField('Imagen', resizedImage);
      //functions.resizeBase64Img(690, node.files[0]).then(resolve).catch(reject);
      functions.getB64ImageFromInputFile(node.files[0]).then(resolve).catch(reject);
    }
  }

  updateAdjunto(evt) {
    evt.preventDefault();
    let node = document.getElementById("adj-raised-button-file");
    if (node != undefined && node != null && node.files != null && node.files.length == 1) {
      const file = node.files[0];
      const filename = file.name;
      const resolve = (Adjunto) => {
        Adjunto = "data:application/octet-stream" + Adjunto.substring(Adjunto.indexOf(";"));
        this.onChangeField('Adjunto', Adjunto.replace("octet-stream", filename));
      };
      functions.getB64FromInputFile(file).then(resolve).catch(resolve);
    }
  }

  render() {
    let vars = this.modalVars();
    const { action } = this.props;
    return (
      <ParadigmaModal
        getUrl={(vars.get ? api.gestion.sitio.novedades : null)}
        submitUrl={(vars.submitType ? api.gestion.sitio.novedades : null)}
        submitType={vars.submitType}
        id={vars.id}

        onGotData={(data) => this.setData(data)}
        onGotErrors={(errors) => this.setErrors(errors)}
        onSubmit={(e) => this.props.onSubmit(e)}
        onClose={() => this.resetForm()}
        onPreSubmit={() => this.getData()}

        title={vars.title}

        danger={vars.danger}
        buttonClass={vars.buttonClass}

        successMessage={vars.successMessage}
        missingIdMessage={"Debe seleccionar una fila."}

        buttonTitle={vars.buttonTitle}
        saveButtonLabel={vars.saveButtonLabel}
        buttonIcon={vars.buttonIcon}
        saveButton={vars.saveButton}
        closeButton={true}
      >
        <label htmlFor={"raised-button-file"} className="m-0 w-100" title="Abrir Explorador de Archivos">
          <div className="img-modal-novedad-holder text-center mx-auto">
            <img height={225} className="img-modal-novedad rounded" src={
              this.state.Imagen == undefined || this.state.Imagen == null || this.state.Imagen == "" ?
                imgNotAvailable
                :
                this.state.Imagen
            } alt="Imagen Novedad" />
          </div>
        </label>
        <input
          type="file"
          accept="image/*"
          id="raised-button-file"
          name="raised-button-file"
          style={{ color: "transparent" }}
          className={vars.disabled == true ? "d-none" : "d-block"}
          onChange={evt => this.updateImage(evt)}
        />
        <hr />
        <ParadigmaLabeledInput
          disabled={vars.disabled}
          md={[2, 10]}
          label={"Titulo"}
          value={this.state.Titulo}
          onChange={(e) => this.onChangeField('Titulo', e.target.value)}
          error={() => this.getError('Titulo')}
        />

        <Row>
          <Col className="my-auto">
            <ParadigmaLabeledInput
              md={[4, 8]}
              label={"Fecha"}
              inputComponent={
                <ParadigmaDatePicker
                  disabled={vars.disabled}
                  value={this.state.Fecha}
                  displayField="Fecha"
                  onChange={(data) => this.setState({ Fecha: data })}
                />
              }
            />
          </Col>
          <Col className="my-auto">
            <ParadigmaCheckBoxInput
              md={[4, 8]}
              labelDerecha={false}
              disabled={vars.disabled}
              switchStyle={true}
              checkmarkOnSwitch={true}
              switchColor={"darkturquoise"}
              label="Destacada"
              value={this.state.Destacada}
              onChange={(newVal) => this.setState({ Destacada: newVal })}
            />
          </Col>
        </Row>

        <ParadigmaLabeledInput
          disabled={vars.disabled}
          label={"Contenido"}
          type={"textarea"}
          rows={4}
          value={this.state.Contenido_HTML}
          onChange={(e) => this.onChangeField('Contenido_HTML', e.target.value)}
          error={() => this.getError('Contenido_HTML')}
        />
        <Row className="mt-2">
          <Col>
            <label htmlFor="adj-raised-button-file" className="m-0 w-100" title="Abrir Explorador de Archivos">
              {
                !(action == "CREATE" || action == "EDIT") && this.state.Adjunto_Link &&
                <a href={this.state.Adjunto_Link} target="_blank"><i class="fa fa-download" aria-hidden="true"></i> Adjunto</a>
              }
              {
                action == "CREATE" || action == "EDIT" &&
                <Fragment>
                  Adjunto
                  <input
                    type="file"
                    disabled={vars.disabled}
                    id="adj-raised-button-file"
                    name="adj-raised-button-file"
                    className={vars.disabled == true ? "d-none" : "d-block"}
                    onChange={evt => this.updateAdjunto(evt)}
                  />
                </Fragment>
              }
            </label>
          </Col>

        </Row>
      </ParadigmaModal>
    );
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/Gestion/Sitio/Novedades/Modal.js